import { AxiosResponse } from "axios";
import { TFunction } from "i18next";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { SeverityEnum } from "../../shared/enum/SeverityEnum";
import { FileUtils } from "../../shared/utils/FileUtils";
import { AdminFormService } from "../services/AdminFormService";

interface Props extends WithTranslation {
}

interface States {
}

class AdminForm extends React.Component<Props, States> {
  private readonly formService: AdminFormService;
  private toast: Toast | null;
  private fileUpload: FileUpload | null;
  private t: TFunction;

  constructor(props: Props) {
    super(props);
    this.formService = new AdminFormService();
    this.t = this.props.t;
    this.toast = null;
    this.fileUpload = null;
  }

  /**
   * On upload
   */
  handleUpload(e: { files: File[] }) {
    if (!e.files) {
      return;
    }
    this.formService
      .uploadForm(e.files[0])
      .then(() => {
        this.toast?.show({
          severity: SeverityEnum.SUCCESS,
          detail: this.t("UI.ADMIN.FORM.TOAST_SUCCESS"),
        });
        this.fileUpload?.clear();
      })
      .catch((err: any) => {
        const message = err?.response?.data?.message;
        this.toast?.show({
          severity: SeverityEnum.ERROR,
          detail: `${this.t("UI.ADMIN.FORM.TOAST_ERROR")}: ${message}`,
        });
      });
  }

  /**
   * On download
   */
  handleDownload() {
    this.formService.downloadForm().then((response: AxiosResponse<Blob>) => {
      FileUtils.downloadFile(response);
    });
  }

  render() {
    return (
      <Card title={this.t("UI.ADMIN.FORM.TITLE")}>
        <Toast ref={(el) => (this.toast = el)}/>
        <Button
          label={this.t("UI.ADMIN.FORM.DOWNLOAD_BUTTON")}
          className="mb-2"
          onClick={() => this.handleDownload()}
        />
        <FileUpload
          ref={(el) => (this.fileUpload = el)}
          mode="basic"
          accept="application/json"
          customUpload={true}
          uploadHandler={(e: { files: File[] }) => this.handleUpload(e)}
          // emptyTemplate={() => <p className="p-m-0">{this.t("ui_admin_form_upload")}</p>}
          chooseLabel={this.t("UI.BUTTON.CHOOSE_FILE")}
          cancelLabel={this.t("UI.BUTTON.CANCEL_FILE")}
          uploadLabel={this.t("UI.BUTTON.UPLOAD_FILE")}
        />
      </Card>
    );
  }
}

export default withTranslation()(AdminForm);
